import React, { useContext } from "react";
import moment from "moment";
import "../../styles/eventCard.css";
import { Link } from "react-router-dom";
import date from "../../assets/details/ic_calendar-blue.svg";
import locationIcon from "../../assets/details/ic_location.svg";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";
const Card = ({
  Title,
  By,
  SDate,
  EDate,
  Image,
  viewInfo,
  id,
  organizer,
  location,
  status,
  extraLanguages,
}) => {
  organizer = organizer
    ? organizer.length > 0
      ? organizer.join(" , ")
      : [""]
    : null;
  // const language = _language.toUpperCase();
  const { language: _language } = useContext(LanguageContext);
  const language = extraLanguages.includes(_language) ? _language : "ENGLISH";

  return (
    <div className={`col-lg-4 col-md-6 col-sm-12 main_event_card `}>
      <div className={`evt_card ${language === "ARABIC" ? "rtl" : "ltr"}`}>
        <div
          className="img-holder"
          style={{
            background: "#fff",
          }}
        >
          <img
            width="272"
            height="170"
            // style={{ height: "auto" }}
            src={Image}
            className="img-responsive wp-post-image"
            loading="lazy"
            alt="eventImage"
          />
        </div>
        <div className="content-wrap">
          <div className="meta">
            <ul>
              <li>
                <span>
                  <img
                    style={{
                      transform: "translateY(-2.8px)",
                    }}
                    width="16"
                    height="14"
                    src={date}
                    alt="date"
                  />
                  &nbsp;&nbsp;
                  {moment(SDate).format("Do MMM, YYYY") === "Invalid date"
                    ? SDate
                    : moment(SDate).format("Do MMM, YYYY")}{" "}
                  &nbsp;- &nbsp;
                  {moment(EDate).format("Do MMM, YYYY") === "Invalid date"
                    ? EDate
                    : moment(EDate).format("Do MMM, YYYY")}
                  &nbsp;
                </span>
              </li>
              <li>
                <span style={{ textTransform: "capitalize" }}>
                  <img
                    style={{
                      transform: "translateY(-2.8px)",
                    }}
                    width="14"
                    height="16"
                    src={locationIcon}
                    alt="location"
                  />
                  &nbsp;{location}&nbsp;
                </span>
              </li>
            </ul>
          </div>
          <h3 className="sustainathon_title">
            <b>{Title}</b>
          </h3>
          <h4>{TEXT[language]["SUSTAINATHONS"]["0"]}</h4>
          <p className="evt-sponsors">{organizer}</p>
        </div>
        <div className="sustainathon_button_module_wrapper sustainathon_button_alignment_center eventcard_button_margin sustainathon-bottom-btn">
          {/* <Link
            to={`/events/${status}/${id}`}
            className="main_button sustainathon_button"
          >
            Learn More
          </Link> */}
          <Link
            className="sustainathon_anim_button sustainathon_button_padding"
            to={`/events/${status}/${id}`}
          >
            <span>{TEXT[language]["SUSTAINATHONS"]["1"]}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Card;
